function NotesIcon({ onClick }: { onClick?: () => void }): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" onClick={onClick}>
      <path d="M25.988,4.4A2.4,2.4,0,0,0,23.6,2H4.4A2.407,2.407,0,0,0,2,4.4V18.8a2.407,2.407,0,0,0,2.4,2.4H21.2L26,26ZM21.2,16.4H6.8V14H21.2Zm0-3.6H6.8V10.4H21.2Zm0-3.6H6.8V6.8H21.2Z" transform="translate(-2 -2)" />
    </svg>
  );
}

export default NotesIcon;
